module.exports = __webpack_public_path__ + "media/t_ppair.e0f3f096.mp3";